// extracted by mini-css-extract-plugin
module.exports = {"container":"block_container__1FB6W","fixed":"block_fixed__2BTmi"};